module.exports = __webpack_public_path__ + "img/module1_icon2.65f1d43b.png";